import ReactDOM from 'react-dom';
import sleep from './sleep.js';

async function fetchResource(url, options, delay, transformUrlRef, transformOptionsRef, transformResponseRef, transformErrorRef, setCacheRef, requestOptionsRef, context, setPendingSafe, setResponseSafe, setErrorSafe, callSideEffectSafe, myController, clientId) {
  let run = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : 1;
  const {
    signal
  } = myController;
  try {
    await sleep(delay, {
      signal
    });
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.error(`Aborted request ${url}`);
    return;
  }
  async function handlePoll(pollTime) {
    try {
      await sleep(pollTime, {
        signal
      });
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(`Aborted request ${url}`);
      return;
    }
    await fetchResource(url, options, delay, transformUrlRef, transformOptionsRef, transformResponseRef, transformErrorRef, setCacheRef, requestOptionsRef, context, setPendingSafe, setResponseSafe, setErrorSafe, callSideEffectSafe, myController, clientId,
    // NOTE: may not need to increase clientId
    1 // NOTE: run should be reset
    );
  }

  async function handleError(message) {
    const {
      shouldRetry,
      shouldPoll
    } = requestOptionsRef.current;
    const retryTime = shouldRetry ? shouldRetry({
      errored: true,
      value: message
    }, run, context) : -1;
    if (retryTime >= 0) {
      try {
        await sleep(retryTime, {
          signal
        });
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(`Aborted request ${url}`);
        return;
      }
      await fetchResource(url, options, delay, transformUrlRef, transformOptionsRef, transformResponseRef, transformErrorRef, setCacheRef, requestOptionsRef, context, setPendingSafe, setResponseSafe, setErrorSafe, callSideEffectSafe, myController, clientId, run + 1);
      return;
    }
    ReactDOM.unstable_batchedUpdates(() => {
      setPendingSafe(false, clientId);
      setResponseSafe(undefined, clientId);
      setErrorSafe(message, clientId);
    });
    const {
      onFailure
    } = requestOptionsRef.current;
    if (onFailure) {
      callSideEffectSafe(() => {
        onFailure(message, context);
      }, clientId);
    }
    const pollTime = shouldPoll ? shouldPoll({
      errored: true,
      value: message
    }, context) : -1;
    if (pollTime > 0) {
      await handlePoll(pollTime);
    }
  }
  async function handleSuccess(response) {
    const {
      shouldRetry,
      shouldPoll
    } = requestOptionsRef.current;
    const retryTime = shouldRetry ? shouldRetry({
      errored: false,
      value: response
    }, run, context) : -1;
    if (retryTime >= 0) {
      try {
        await sleep(retryTime, {
          signal
        });
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(`Aborted request ${url}`);
        return;
      }
      await fetchResource(url, options, delay, transformUrlRef, transformOptionsRef, transformResponseRef, transformErrorRef, setCacheRef, requestOptionsRef, context, setPendingSafe, setResponseSafe, setErrorSafe, callSideEffectSafe, myController, clientId, run + 1);
      return;
    }
    ReactDOM.unstable_batchedUpdates(() => {
      setPendingSafe(false, clientId);
      setErrorSafe(undefined, clientId);
      if (options.method === 'GET' && setCacheRef.current) {
        setCacheRef.current(url, response);
      }
      setResponseSafe(response, clientId);
    });
    const {
      onSuccess
    } = requestOptionsRef.current;
    if (onSuccess) {
      callSideEffectSafe(() => {
        onSuccess(response, context);
      }, clientId);
    }
    const pollTime = shouldPoll ? shouldPoll({
      errored: false,
      value: response
    }, context) : -1;
    if (pollTime > 0) {
      await handlePoll(pollTime);
    }
  }
  const myUrl = transformUrlRef.current(url, options, requestOptionsRef.current);
  const myOptions = transformOptionsRef.current(url, options, requestOptionsRef.current);
  let res;
  try {
    res = await fetch(myUrl, {
      ...myOptions,
      signal
    });
  } catch (e) {
    if (!signal.aborted) {
      // eslint-disable-next-line no-console
      console.error(`An error occurred while fetching ${myUrl}`, e);
      const transformedError = transformErrorRef.current('network', url, options, requestOptionsRef.current);
      await handleError(transformedError);
    }
    return;
  }
  let resBody;
  try {
    resBody = await transformResponseRef.current(res, url, options, requestOptionsRef.current);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`An error occurred while parsing ${myUrl}`, e);
    const transformedError = transformErrorRef.current('parse', url, options, requestOptionsRef.current);
    await handleError(transformedError);
    return;
  }
  if (!res.ok) {
    const transformedError = transformErrorRef.current(resBody, url, options, requestOptionsRef.current);
    await handleError(transformedError);
    return;
  }
  await handleSuccess(resBody);
}

export { fetchResource as default };
//# sourceMappingURL=fetch.js.map
